/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ, assets/faq.js
 * Version i18n : FR/EN via window.KM_LANG
 * ════════════════════════════════════════════════════════════════════
 */

(function() {

var KM_LANG = (window.KM_LANG || 'fr').toLowerCase();

var FAQ_DATA_FR = [
  {
    cat: 'commande',
    label: 'Commande & livraison',
    emoji: 'cart',
    items: [
      {
        question: "Comment passer commande sur KeepMemoriz ?",
        answer: '<p>Passez commande directement sur notre boutique en ligne en quelques clics :</p><ul><li>Sélectionnez votre carte de table (album QR code + 15 cartes de table)</li><li>Personnalisez vos cartes de table : prénoms et nom de votre événement</li><li>Validez votre panier et réglez en ligne</li><li>Recevez votre accès à l\'album et votre carte de table par email en quelques minutes</li></ul><p><strong>Accès immédiat</strong> après validation du paiement, aucune attente.</p>'
      },
      {
        question: "Sous quel délai est-ce que je reçois ma commande ?",
        answer: '<p><strong>Accès numérique immédiat</strong> : votre album est activé et vos fichiers de cartes de table sont envoyés par email dans les <strong>5 à 10 minutes</strong> suivant la validation de votre paiement.</p>'
      },
      {
        question: "Quels modes de paiement acceptez-vous ?",
        answer: '<p>Nous acceptons tous les moyens de paiement sécurisés via Shopify Payments :</p><ul><li>Carte bancaire (Visa, Mastercard, American Express)</li><li>Apple Pay et Google Pay</li><li>PayPal</li></ul><p>Toutes les transactions sont sécurisées et chiffrées. Nous ne stockons aucune donnée bancaire.</p>'
      },
      {
        question: "Est-ce que je peux modifier ma commande après validation ?",
        answer: '<p>Vous pouvez modifier la personnalisation de vos cartes de table (prénoms, date, message) dans les <strong>24 heures suivant votre commande</strong>, en nous contactant par email.</p><p>Au-delà de ce délai, si les fichiers ont déjà été générés, des modifications peuvent entraîner des frais supplémentaires. Contactez-nous dès que possible.</p>'
      },
      {
        question: "Proposez-vous une politique de remboursement ?",
        answer: '<p>Oui. Nous offrons une <strong>garantie satisfait ou remboursé de 30 jours</strong>.</p><p>Si vous n\'êtes pas satisfait de votre achat pour quelque raison que ce soit, contactez-nous par email dans les 30 jours suivant votre commande et nous procédons au remboursement intégral, sans question.</p><p>Pour toute demande de remboursement : <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a></p>'
      }
    ]
  },
  {
    cat: 'album',
    label: 'Album & QR code',
    emoji: 'camera',
    items: [
      {
        question: "Comment fonctionne l'album partagé KeepMemoriz ?",
        answer: '<p>L\'album KeepMemoriz fonctionne en 3 étapes simples :</p><ul><li><strong>Vous créez</strong> votre album privé en ligne lors de votre commande</li><li><strong>Vous placez</strong> vos cartes de table QR code lors de votre événement (tables, entrée, bar…)</li><li><strong>Vos invités scannent</strong> le QR code avec l\'appareil photo natif de leur téléphone et déposent leurs photos directement dans votre album</li></ul><p><strong>Aucune application à télécharger, aucun compte à créer</strong> pour vos invités. Juste un scan.</p>'
      },
      {
        question: "Combien de photos peut-on partager dans l'album ?",
        answer: '<p>Il n\'y a <strong>aucune limite</strong> au nombre de photos que vos invités peuvent partager. Que vous ayez 50 ou 300 invités, l\'album accueille tout.</p><p>En moyenne, nos clients reçoivent entre <strong>200 et 600 photos et vidéos</strong> selon la taille de leur événement.</p>'
      },
      {
        question: "Combien de temps l'album reste-t-elle accessible ?",
        answer: '<p>Votre album est accessible pendant <strong>6 mois</strong> à compter de la date de création. Téléchargez vos photos et vidéos à tout moment pendant cette période.</p>'
      },
      {
        question: "Puis-je télécharger toutes les photos en une seule fois ?",
        answer: '<p>Oui. Depuis votre espace KeepMemoriz, vous pouvez télécharger l\'intégralité des photos en <strong>un seul fichier ZIP</strong>, en pleine résolution.</p><p>Toutes les photos sont conservées dans leur résolution originale, aucune compression, aucune perte de qualité.</p>'
      },
      {
        question: "Est-ce que plusieurs personnes peuvent utiliser le même QR code simultanément ?",
        answer: '<p>Oui, absolument. Le QR code peut être scanné par <strong>autant de personnes que vous voulez, en même temps</strong>. Il n\'y a aucune limite de connexions simultanées.</p><p>Tous vos invités peuvent déposer leurs photos et vidéos au même moment sans aucun problème technique.</p>'
      }
    ]
  },
  {
    cat: 'cartes de table',
    label: 'Cartes de table QR code',
    emoji: 'printer',
    items: [
      {
        question: "Combien de cartes de table sont incluses dans ma commande ?",
        answer: '<p>Votre commande inclut <strong>15 cartes de table personnalisées</strong> dans différents formats :</p><ul><li>Formats A5, A4 et A3 pour les tables, l\'entrée et le bar</li><li>15 designs graphiques différents au choix</li><li>Personnalisées avec vos prénoms, votre date et votre événement</li></ul><p>Vous recevez les fichiers haute résolution par email, prêts à imprimer.</p>'
      },
      {
        question: "Comment imprimer mes cartes de table ?",
        answer: '<p>Vous recevez vos cartes de table en <strong>fichiers PDF haute résolution</strong>, prêts à imprimer :</p><ul><li><strong>Chez vous</strong> sur une imprimante standard (qualité correcte pour les petits formats)</li><li><strong>En ligne</strong> : Canson, Vistaprint, Photobox, qualité professionnelle</li><li><strong>En magasin</strong> : Fnac, Bureau Vallée, Cultura</li></ul><p>Pour les grands formats (A2, miroir de bienvenue), nous recommandons une impression chez un imprimeur professionnel.</p>'
      },
      {
        question: "Puis-je personnaliser les cartes de table avec mon propre design ?",
        answer: '<p>Les cartes de table sont personnalisées avec vos prénoms, votre date et votre message dans le cadre de l\'un de nos <strong>15 thèmes graphiques</strong>.</p><p>Si vous souhaitez un design totalement sur mesure, contactez-nous à <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a> pour discuter d\'une création personnalisée.</p>'
      },
      {
        question: "Quelle est la taille d'impression recommandée pour les tables ?",
        answer: '<p>Voici nos recommandations selon les emplacements :</p><ul><li><strong>Tables de dîner</strong> : A5 (14,8 × 21 cm) dans un chevalet, idéal</li><li><strong>Table d\'accueil ou de cadeaux</strong> : A4 (21 × 29,7 cm)</li><li><strong>Entrée du lieu ou couloir</strong> : A3 (29,7 × 42 cm) ou grand format</li><li><strong>Miroir de bienvenue</strong> : A2 ou sur-mesure</li></ul>'
      }
    ]
  },
  {
    cat: 'technique',
    label: 'Technique & utilisation',
    emoji: 'settings',
    items: [
      {
        question: "Faut-il télécharger une application pour scanner le QR code ?",
        answer: '<p><strong>Non, aucune application n\'est nécessaire.</strong></p><p>Vos invités scannent simplement avec l\'<strong>appareil photo natif</strong> de leur smartphone (iOS ou Android). Un lien s\'affiche automatiquement, ils cliquent et accèdent à l\'album.</p><p>Aucun compte à créer, aucune inscription. Le processus prend moins de 10 secondes.</p>'
      },
      {
        question: "Le QR code fonctionne-t-il sur tous les téléphones ?",
        answer: '<p>Oui. Le QR code est compatible avec :</p><ul><li><strong>iPhone</strong> : scan natif avec l\'app Appareil photo</li><li><strong>Android</strong> : scan natif ou via Google Lens</li><li>Tout smartphone disposant d\'un appareil photo fonctionnel</li></ul><p>Pour les téléphones plus anciens, n\'importe quelle application de scan QR code gratuite fonctionne.</p>'
      },
      {
        question: "Les invités ont-ils besoin d'une connexion internet pour partager leurs photos ?",
        answer: '<p>Oui, une connexion internet est nécessaire pour déposer les photos et vidéos dans l\'album.</p><p><strong>Conseil pratique</strong> : partagez le code WiFi du lieu avec vos invités, mentionnez-le sur vos cartes de table ou dans le programme. Cela facilite l\'envoi des photos, surtout dans les lieux avec peu de réseau 4G.</p>'
      },
      {
        question: "Est-ce que les vidéos sont acceptées en plus des photos ?",
        answer: '<p><strong>Oui</strong>, vos invités peuvent partager des photos <strong>et des vidéos</strong> dans l\'album.</p><p>Les vidéos sont stockées en pleine qualité, sans compression. Vous pouvez toutes les télécharger depuis votre espace KeepMemoriz.</p>'
      },
      {
        question: "Combien de temps faut-il pour configurer l'album ?",
        answer: '<p>La configuration complète prend <strong>moins de 5 minutes</strong> :</p><ul><li>Créez votre album lors de votre commande</li><li>Personnalisez votre carte de table en quelques clics</li><li>Téléchargez votre fichier PDF et imprimez-le</li></ul><p>Le jour J, il n\'y a rien à faire côté technique. Placez les cartes de table et c\'est tout.</p>'
      }
    ]
  },
  {
    cat: 'confidentialite',
    label: 'Confidentialité & sécurité',
    emoji: 'lock',
    items: [
      {
        question: "L'album est-il privé ?",
        answer: '<p><strong>Oui, totalement.</strong> Votre album est protégée par un lien unique et sécurisé.</p><ul><li>Les photos ne sont <strong>pas indexées</strong> sur les moteurs de recherche</li><li>L\'album n\'est <strong>pas visible publiquement</strong>, seules les personnes ayant le QR code peuvent y accéder</li><li>Vos photos ne sont <strong>jamais partagées</strong> sur les réseaux sociaux ni avec des tiers</li></ul>'
      },
      {
        question: "Qui peut voir les photos dans mon album ?",
        answer: '<p>Uniquement les personnes qui ont accès au QR code, c\'est-à-dire vos invités présents à l\'événement.</p><p>En tant que propriétaire de l\'album, vous êtes le seul à pouvoir gérer les photos, les vidéos, les télécharger et éventuellement les supprimer.</p>'
      },
      {
        question: "Mes données personnelles sont-elles protégées ?",
        answer: '<p>Oui. KeepMemoriz respecte le <strong>RGPD</strong> (Règlement Général sur la Protection des Données).</p><ul><li>Vos données personnelles ne sont jamais revendues à des tiers</li><li>Nous n\'utilisons vos informations que pour gérer votre commande et votre album</li><li>Vous pouvez demander la suppression de votre compte et de vos données à tout moment</li></ul><p>Pour toute demande relative à vos données : <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a></p>'
      },
      {
        question: "Les photos sont-elles sauvegardées de façon sécurisée ?",
        answer: '<p>Oui. Vos photos et vidéos sont hébergées sur des serveurs sécurisés avec :</p><ul><li>Chiffrement des données en transit (HTTPS)</li><li>Sauvegardes automatiques régulières</li><li>Infrastructure hébergée en Europe</li></ul><p>Votre album et vos souvenirs sont protégés à long terme.</p>'
      }
    ]
  },
  {
    cat: 'diffusion',
    label: 'Diffusion en direct',
    emoji: 'screen',
    items: [
      {
        question: "Comment activer la diffusion en direct sur un écran ?",
        answer: '<p>Depuis votre espace client, ouvrez votre galerie et cliquez sur le bouton <strong>Diffusion</strong>. Paramétrez vos préférences puis lancez. Les photos de vos invités s\'affichent en temps réel sur l\'écran connecté à votre ordinateur.</p>'
      },
      {
        question: "Quel matériel faut-il pour la diffusion en direct ?",
        answer: '<p>Un ordinateur avec un navigateur web récent, connecté à un écran, TV ou projecteur via HDMI ou sans fil. Une connexion internet stable est nécessaire pour que les photos arrivent en temps réel.</p>'
      }
    ]
  }
];

var FAQ_DATA_EN = [
  {
    cat: 'commande',
    label: 'Order & delivery',
    emoji: 'cart',
    items: [
      {
        question: "How do I place an order on KeepMemoriz?",
        answer: '<p>Order directly from our online store in just a few clicks:</p><ul><li>Select your poster (QR code gallery + 15 posters)</li><li>Customize your posters: first names and event name</li><li>Confirm your cart and pay online</li><li>Receive your gallery access and poster by email within minutes</li></ul><p><strong>Instant access</strong> after payment confirmation, no waiting.</p>'
      },
      {
        question: "How quickly will I receive my order?",
        answer: '<p><strong>Instant digital access</strong>: your gallery is activated and your poster files are sent by email within <strong>5 to 10 minutes</strong> of payment confirmation.</p>'
      },
      {
        question: "What payment methods do you accept?",
        answer: '<p>We accept all secure payment methods via Shopify Payments:</p><ul><li>Credit card (Visa, Mastercard, American Express)</li><li>Apple Pay and Google Pay</li><li>PayPal</li></ul><p>All transactions are secure and encrypted. We do not store any banking data.</p>'
      },
      {
        question: "Can I modify my order after it has been confirmed?",
        answer: '<p>You can modify your poster customization (names, date, message) within <strong>24 hours of your order</strong> by contacting us via email.</p><p>After this period, if files have already been generated, modifications may incur additional charges. Please contact us as soon as possible.</p>'
      },
      {
        question: "Do you offer a refund policy?",
        answer: '<p>Yes. We offer a <strong>30-day money-back guarantee</strong>.</p><p>If you are not satisfied with your purchase for any reason, contact us by email within 30 days of your order and we will process a full refund, no questions asked.</p><p>For any refund request: <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a></p>'
      }
    ]
  },
  {
    cat: 'album',
    label: 'Gallery & QR code',
    emoji: 'camera',
    items: [
      {
        question: "How does the KeepMemoriz shared gallery work?",
        answer: '<p>The KeepMemoriz gallery works in 3 simple steps:</p><ul><li><strong>You create</strong> your private gallery online when you order</li><li><strong>You place</strong> your QR code posters at your event (tables, entrance, bar…)</li><li><strong>Your guests scan</strong> the QR code with their phone\'s native camera and upload their photos directly to your gallery</li></ul><p><strong>No app to download, no account to create</strong> for your guests. Just a scan.</p>'
      },
      {
        question: "How many photos can be shared in the gallery?",
        answer: '<p>There is <strong>no limit</strong> to the number of photos your guests can share. Whether you have 50 or 300 guests, the gallery handles it all.</p><p>On average, our customers receive between <strong>200 and 600 photos and videos</strong> depending on their event size.</p>'
      },
      {
        question: "How long does the gallery remain accessible?",
        answer: '<p>Your gallery is accessible for <strong>6 months</strong> from the date of creation. Download your photos and videos at any time during this period.</p>'
      },
      {
        question: "Can I download all the photos at once?",
        answer: '<p>Yes. From your KeepMemoriz dashboard, you can download all photos in <strong>a single ZIP file</strong>, in full resolution.</p><p>All photos are preserved in their original resolution, no compression, no quality loss.</p>'
      },
      {
        question: "Can multiple people use the same QR code simultaneously?",
        answer: '<p>Yes, absolutely. The QR code can be scanned by <strong>as many people as you want, at the same time</strong>. There is no limit on simultaneous connections.</p><p>All your guests can upload their photos and videos at the same moment without any technical issues.</p>'
      }
    ]
  },
  {
    cat: 'cartes de table',
    label: 'QR code posters',
    emoji: 'printer',
    items: [
      {
        question: "How many posters are included in my order?",
        answer: '<p>Your order includes <strong>15 personalized posters</strong> in different formats:</p><ul><li>A5, A4, and A3 formats for tables, entrance, and bar</li><li>15 different graphic designs to choose from</li><li>Personalized with your names, date, and event</li></ul><p>You receive high-resolution files by email, ready to print.</p>'
      },
      {
        question: "How do I print my posters?",
        answer: '<p>You receive your posters as <strong>high-resolution PDF files</strong>, ready to print:</p><ul><li><strong>At home</strong> on a standard printer (good quality for small formats)</li><li><strong>Online</strong>: Vistaprint, Shutterfly, or similar services for professional quality</li><li><strong>In store</strong>: Staples, Office Depot, or local print shops</li></ul><p>For large formats (A2, welcome mirror), we recommend using a professional printer.</p>'
      },
      {
        question: "Can I customize the posters with my own design?",
        answer: '<p>The posters are customized with your names, date, and message using one of our <strong>15 graphic themes</strong>.</p><p>If you want a fully custom design, contact us at <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a> to discuss a bespoke creation.</p>'
      },
      {
        question: "What is the recommended print size for tables?",
        answer: '<p>Here are our recommendations by location:</p><ul><li><strong>Dinner tables</strong>: A5 (5.8 × 8.3 in) in a table tent, ideal</li><li><strong>Welcome or gift table</strong>: A4 (8.3 × 11.7 in)</li><li><strong>Venue entrance or hallway</strong>: A3 (11.7 × 16.5 in) or larger</li><li><strong>Welcome mirror</strong>: A2 or custom size</li></ul>'
      }
    ]
  },
  {
    cat: 'technique',
    label: 'Technical & usage',
    emoji: 'settings',
    items: [
      {
        question: "Do I need to download an app to scan the QR code?",
        answer: '<p><strong>No, no app is needed.</strong></p><p>Your guests simply scan with their smartphone\'s <strong>native camera</strong> (iOS or Android). A link appears automatically, they tap and access the gallery.</p><p>No account to create, no sign-up. The process takes less than 10 seconds.</p>'
      },
      {
        question: "Does the QR code work on all phones?",
        answer: '<p>Yes. The QR code is compatible with:</p><ul><li><strong>iPhone</strong>: native scan with the Camera app</li><li><strong>Android</strong>: native scan or via Google Lens</li><li>Any smartphone with a working camera</li></ul><p>For older phones, any free QR code scanner app will work.</p>'
      },
      {
        question: "Do guests need an internet connection to share their photos?",
        answer: '<p>Yes, an internet connection is needed to upload photos and videos to the gallery.</p><p><strong>Practical tip</strong>: share the venue\'s WiFi password with your guests, mention it on your posters or in the program. This makes sharing photos easier, especially in venues with poor 4G coverage.</p>'
      },
      {
        question: "Are videos accepted in addition to photos?",
        answer: '<p><strong>Yes</strong>, your guests can share photos <strong>and videos</strong> in the gallery.</p><p>Videos are stored in full quality, without compression. You can download them all from your KeepMemoriz dashboard.</p>'
      },
      {
        question: "How long does it take to set up the gallery?",
        answer: '<p>The complete setup takes <strong>less than 5 minutes</strong>:</p><ul><li>Create your gallery when you order</li><li>Customize your poster in a few clicks</li><li>Download your PDF file and print it</li></ul><p>On the day, there\'s nothing to do technically. Place the posters and that\'s it.</p>'
      }
    ]
  },
  {
    cat: 'confidentialite',
    label: 'Privacy & security',
    emoji: 'lock',
    items: [
      {
        question: "Is the gallery private?",
        answer: '<p><strong>Yes, completely.</strong> Your gallery is protected by a unique, secure link.</p><ul><li>Photos are <strong>not indexed</strong> by search engines</li><li>The gallery is <strong>not publicly visible</strong>, only people with the QR code can access it</li><li>Your photos are <strong>never shared</strong> on social media or with third parties</li></ul>'
      },
      {
        question: "Who can see the photos in my gallery?",
        answer: '<p>Only people who have access to the QR code, meaning your guests who were at the event.</p><p>As the gallery owner, you are the only one who can manage photos, videos, download them, and potentially delete them.</p>'
      },
      {
        question: "Is my personal data protected?",
        answer: '<p>Yes. KeepMemoriz complies with the <strong>GDPR</strong> (General Data Protection Regulation).</p><ul><li>Your personal data is never sold to third parties</li><li>We only use your information to manage your order and gallery</li><li>You can request deletion of your account and data at any time</li></ul><p>For any data-related requests: <a href="mailto:contact@keepmemoriz.com">contact@keepmemoriz.com</a></p>'
      },
      {
        question: "Are photos stored securely?",
        answer: '<p>Yes. Your photos and videos are hosted on secure servers with:</p><ul><li>Data encryption in transit (HTTPS)</li><li>Regular automatic backups</li><li>Infrastructure hosted in Europe</li></ul><p>Your gallery and memories are protected long-term.</p>'
      }
    ]
  },
  {
    cat: 'diffusion',
    label: 'Live broadcast',
    emoji: 'screen',
    items: [
      {
        question: "How do I activate the live broadcast on a screen?",
        answer: '<p>From your dashboard, open your gallery and click the <strong>Broadcast</strong> button. Set your preferences and launch. Your guests\' photos will display in real time on the screen connected to your computer.</p>'
      },
      {
        question: "What equipment do I need for the live broadcast?",
        answer: '<p>A computer with a modern web browser, connected to a screen, TV, or projector via HDMI or wirelessly. A stable internet connection is required for photos to arrive in real time.</p>'
      }
    ]
  }
];

var FAQ_DATA = KM_LANG === 'en' ? FAQ_DATA_EN : FAQ_DATA_FR;

/* ── UI strings ── */
var FAQ_UI = KM_LANG === 'en' ? {
  noResultFor: 'No results for',
  questionsFound: 'question(s) found for',
  noResultFilled: 'Please fill in all required fields.',
  emailInvalid: 'Please enter a valid email address.',
  msgSent: 'Message sent',
  verifiedPurchase: 'Verified purchase',
  teamReply: 'KeepMemoriz team reply'
} : {
  noResultFor: 'Aucun résultat pour',
  questionsFound: 'question(s) trouvée(s) pour',
  noResultFilled: 'Veuillez remplir tous les champs obligatoires.',
  emailInvalid: 'Veuillez entrer une adresse email valide.',
  msgSent: 'Message envoyé',
  verifiedPurchase: 'Achat vérifié',
  teamReply: "Réponse de l'équipe KeepMemoriz"
};


var FAQ_ICONS = {
  cart: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
  camera: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
  printer: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><path d="M6 9V2h12v7"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>',
  settings: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
  lock: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
  screen: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>'
};

function renderFAQ(searchQuery, activeCat) {
  searchQuery = searchQuery || '';
  activeCat = activeCat || 'toutes';
  var container = document.getElementById('faqAccordion');
  var noResults = document.getElementById('faqNoResults');
  var countEl = document.getElementById('faqSearchCount');
  if (!container) return;
  var q = searchQuery.toLowerCase().trim();

  var totalVisible = 0;
  var html = '';

  FAQ_DATA.forEach(function(group) {
    if (activeCat !== 'toutes' && group.cat !== activeCat) return;

    var visibleItems = group.items.filter(function(item) {
      if (!q || q.length < 2) return true;
      return item.question.toLowerCase().indexOf(q) !== -1 || item.answer.toLowerCase().indexOf(q) !== -1;
    });

    if (visibleItems.length === 0) return;
    totalVisible += visibleItems.length;

    html += '<div class="faq-cat-group" data-cat="'+group.cat+'">';
    html += '<h2 class="faq-cat-title">'+(FAQ_ICONS[group.emoji] || '')+' <em>'+group.label+'</em></h2>';
    visibleItems.forEach(function(item, i) {
      var id = 'faq-'+group.cat+'-'+i;
      var highlightedQ = q.length >= 2
        ? item.question.replace(new RegExp('('+q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','gi'),'<mark>$1</mark>')
        : item.question;
      html += '<div class="faq-item" id="'+id+'">';
      html += '<button class="faq-question" aria-expanded="false" aria-controls="'+id+'-answer" onclick="toggleFAQ(\''+id+'\')"> ';
      html += '<span class="faq-q-text">'+highlightedQ+'</span>';
      html += '<span class="faq-icon" aria-hidden="true">+</span>';
      html += '</button>';
      html += '<div class="faq-answer" id="'+id+'-answer" role="region"><div class="faq-answer-inner">'+item.answer+'</div></div>';
      html += '</div>';
    });
    html += '</div>';
  });

  if (totalVisible === 0) {
    container.innerHTML = '';
    if (noResults) noResults.style.display = 'block';
  } else {
    if (noResults) noResults.style.display = 'none';
    container.innerHTML = html;
  }

  if (countEl) {
    if (q.length >= 2) {
      countEl.textContent = totalVisible === 0
        ? FAQ_UI.noResultFor + ' "' + searchQuery + '"'
        : totalVisible + ' ' + FAQ_UI.questionsFound + ' "' + searchQuery + '"';
    } else {
      countEl.textContent = '';
    }
  }
}


function toggleFAQ(id) {
  var item = document.getElementById(id);
  if (!item) return;
  var isOpen = item.classList.contains('open');

  item.closest('.faq-cat-group').querySelectorAll('.faq-item.open').forEach(function(el) {
    if (el !== item) {
      el.classList.remove('open');
      el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
    }
  });

  item.classList.toggle('open', !isOpen);
  item.querySelector('.faq-question').setAttribute('aria-expanded', String(!isOpen));
}

/* Expose toggleFAQ globally (used in inline onclick) */
window.toggleFAQ = toggleFAQ;

var currentFaqCat = 'toutes';
var currentFaqSearch = '';

document.querySelectorAll('.faq-cat-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.faq-cat-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    currentFaqCat = btn.dataset.cat;
    currentFaqSearch = '';
    var searchEl = document.getElementById('faqSearch');
    var countEl = document.getElementById('faqSearchCount');
    if (searchEl) searchEl.value = '';
    if (countEl) countEl.textContent = '';
    renderFAQ('', currentFaqCat);
    var accordion = document.getElementById('faqAccordion');
    if (accordion) accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

var faqSearchEl = document.getElementById('faqSearch');
if (faqSearchEl) {
  var faqSearchTimer;
  faqSearchEl.addEventListener('input', function(e) {
    clearTimeout(faqSearchTimer);
    var val = e.target.value;
    faqSearchTimer = setTimeout(function() {
      currentFaqSearch = val.trim();
      if (currentFaqSearch.length >= 2) {
        currentFaqCat = 'toutes';
        document.querySelectorAll('.faq-cat-btn').forEach(function(b) { b.classList.remove('active'); });
        var allBtn = document.querySelector('[data-cat="toutes"]');
        if (allBtn) allBtn.classList.add('active');
      }
      renderFAQ(currentFaqSearch, currentFaqCat);
    }, 200);
  });
}

var contactToggleBtn = document.getElementById('contactToggleBtn');
var contactFormWrap = document.getElementById('contactFormWrap');
var shopifyForm = document.getElementById('shopifyContactForm');
var formErrorMsg = document.getElementById('formErrorMsg');
var formSuccess = document.getElementById('formSuccess');
var submitBtn = document.getElementById('formSubmitBtn');
var submitBtnText = document.getElementById('submitBtnText');
var submitBtnLoader = document.getElementById('submitBtnLoader');

if (contactToggleBtn && contactFormWrap) {
  contactToggleBtn.addEventListener('click', function() {
    var isOpen = contactFormWrap.classList.contains('open');
    contactFormWrap.classList.toggle('open', !isOpen);
    contactToggleBtn.classList.toggle('open', !isOpen);
    contactToggleBtn.setAttribute('aria-expanded', String(!isOpen));
    contactFormWrap.setAttribute('aria-hidden', String(isOpen));
    if (!isOpen) {
      setTimeout(function() {
        contactFormWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 300);
    }
  });
}

function validateContactForm() {
  var nameEl = document.getElementById('contact_name');
  var emailEl = document.getElementById('contact_email');
  var bodyEl = document.getElementById('contact_body');
  if (!nameEl || !emailEl || !bodyEl) return false;
  var name = nameEl.value.trim();
  var email = emailEl.value.trim();
  var body = bodyEl.value.trim();
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!name || !email || !body) {
    if (formErrorMsg) {
      formErrorMsg.textContent = FAQ_UI.noResultFilled;
      formErrorMsg.classList.add('visible');
    }
    return false;
  }
  if (!emailRegex.test(email)) {
    if (formErrorMsg) {
      formErrorMsg.textContent = FAQ_UI.emailInvalid;
      formErrorMsg.classList.add('visible');
    }
    return false;
  }
  if (formErrorMsg) formErrorMsg.classList.remove('visible');
  return true;
}

if (shopifyForm) {
  shopifyForm.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!validateContactForm()) return;

    if (submitBtn) submitBtn.disabled = true;
    if (submitBtnText) submitBtnText.style.display = 'none';
    if (submitBtnLoader) submitBtnLoader.style.display = 'inline';

    var formData = new FormData(shopifyForm);
    fetch('/contact', {
      method: 'POST',
      headers: { 'Accept': 'application/json, text/html, */*' },
      body: formData
    }).then(function(response) {
      if (response.ok) {
        shopifyForm.style.display = 'none';
        if (formSuccess) {
          formSuccess.classList.add('visible');
          formSuccess.onclick = function() { formSuccess.classList.remove('visible'); };
          setTimeout(function() { formSuccess.classList.remove('visible'); }, 10000);
        }
        if (contactToggleBtn) {
          contactToggleBtn.textContent = FAQ_UI.msgSent;
          contactToggleBtn.style.background = '#4A7C59';
          contactToggleBtn.disabled = true;
        }
      } else {
        throw new Error('Server error: ' + response.status);
      }
    }).catch(function(err) {
      console.warn('Fetch failed, classic submit:', err);
      shopifyForm.submit();
    });
  });
}

['contact_name', 'contact_email', 'contact_body'].forEach(function(id) {
  var el = document.getElementById(id);
  if (el) {
    el.addEventListener('input', function() {
      if (formErrorMsg) formErrorMsg.classList.remove('visible');
    });
  }
});

var revealObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(x) {
    if (!x.isIntersecting) return;
    x.target.classList.add('visible');
    revealObserver.unobserve(x.target);
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(function(el) { revealObserver.observe(el); });

if (window.location.hash === '#contact') {
  setTimeout(function() {
    if (contactFormWrap && contactToggleBtn) {
      contactFormWrap.classList.add('open');
      contactToggleBtn.classList.add('open');
      contactToggleBtn.setAttribute('aria-expanded', 'true');
      contactFormWrap.setAttribute('aria-hidden', 'false');
      var contactZone = document.getElementById('contactZone');
      if (contactZone) contactZone.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 500);
}

/* Détection post-redirect après captcha Shopify */
if (window.location.search.indexOf('contact_posted=true') !== -1) {
  setTimeout(function() {
    if (contactFormWrap && contactToggleBtn) {
      contactFormWrap.classList.add('open');
      contactToggleBtn.classList.add('open');
      contactToggleBtn.setAttribute('aria-expanded', 'true');
      contactFormWrap.setAttribute('aria-hidden', 'false');
      if (contactToggleBtn) {
        contactToggleBtn.textContent = FAQ_UI.msgSent;
        contactToggleBtn.style.background = '#4A7C59';
        contactToggleBtn.disabled = true;
      }
    }
    if (shopifyForm) shopifyForm.style.display = 'none';
    if (formSuccess) {
      formSuccess.classList.add('visible');
      formSuccess.onclick = function() { formSuccess.classList.remove('visible'); };
      setTimeout(function() { formSuccess.classList.remove('visible'); }, 10000);
    }
    var contactZone = document.getElementById('contactZone');
    if (contactZone) contactZone.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, 400);
}

/* Initialisation */
renderFAQ();

})();